import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import { GROUP_RESERVATIONS, RES_UNAVAILABLE_GR_ENABLED } from 'constants/featureToggleNames';

function useGroupReservationsEnabled() {
  const [isFtLoading, features] = useFeatureToggle([GROUP_RESERVATIONS, RES_UNAVAILABLE_GR_ENABLED]);
  const isGREnabled = features[GROUP_RESERVATIONS];
  const isResUnavailableGREnabled = features[RES_UNAVAILABLE_GR_ENABLED];

  return {
    isFtLoading,
    enabled: isGREnabled && !isResUnavailableGREnabled,
  };
}

export default useGroupReservationsEnabled;
